var render = function render(){var _vm=this,_c=_vm._self._c;return _c('feather-icon',{staticClass:"cursor-pointer navbar-fuzzy-search ml-4",staticStyle:{"color":"#626262"},attrs:{"icon":"PlayIcon"},on:{"click":_vm.startDemo}})
}
var staticRenderFns = []

export { render, staticRenderFns }